/* src/app/views/template/components/edit-template-menu/edit-template-shelf-talker-menu/edit-template-shelf-talker-menu-footer/edit-template-shelf-talker-menu-footer.component.scss */
/*# sourceMappingURL=edit-template-shelf-talker-menu-footer.component.css.map */
